module.exports = __webpack_public_path__ + "img/gu.0475f5da.svg";